



import { Component, forwardRef, Input, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ControlValueAccessor, Validator, NG_VALUE_ACCESSOR, NG_VALIDATORS, FormGroup, FormControl, AbstractControl } from '@angular/forms';;

@Component({
  selector: 'taly-custom-textarea',
  templateUrl: './custom-textarea.component.html',
  styleUrls: ['./custom-textarea.component.scss'],
  providers: [
    { 
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomTextareaComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CustomTextareaComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomTextareaComponent implements ControlValueAccessor {

  @Input( { required : true } ) id: string = '';
  @Input( { required : true } ) label: string = '';
  @Input() placeholderText?:string = '';
  @Input() inputType? : any = 'input';
  @Input() formGroup!: FormGroup;
  @Input() controlName!: string;
  @Input() min! : number;
  @Input() max! : number;
  @Input() inputmodeType : string = "none"
  
  @Input() set isDisabled(disable: boolean) {
    this.disabled = disable;
  }
  resizeTextarea(textarea: HTMLTextAreaElement): void {
    textarea.style.height = 'auto';  
    textarea.style.height = `${textarea.scrollHeight}px`; 
  }

  disabled = false;

  get f() {
    return this.formGroup?.controls;
  }

  currentLength = 0; // To hold the current character length

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  private _value:  any | null = null; 

  set value(value: any) {
    this._value = value;
    this.onChange(value);
  }

  get value(): any {
    return this._value;
  }
  get control() {
    return this.formGroup.get(this.controlName);
  }

  ngOnInit() {
    this.currentLength = this.control?.value.length || 0; // Initialize with existing value length
    this.control?.valueChanges.subscribe(value => {
      this.currentLength = value.length;
    });

  }

  onChange(event:any){
  
  }

  onReset(event:any){
    // event.inputField = null;
    // this._value = null

    if (this.formGroup && this.controlName) {
      this.formGroup.get(this.controlName)?.setValue(null); // Set the value in the form control
    }
  }

  onTouched = () => {};

  writeValue(value: any) {
    this.value = value;
    if (this.changeDetectorRef) {
      this.changeDetectorRef.markForCheck();
    }
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  // Implement the validator function
  validate(control: AbstractControl) {
    // if (control.value !== null && (isNaN(control.value) || control.value < 10 || control.value > 100)) {
    //   return { invalidRange: true };
    // }
    return null;
  }
}